<template>
  <div class="animated fadeIn">
    <div v-if="!dataEmpty" ref="chart" style="width: 100%; height: 200px;"></div>
    <b-alert v-if="dataEmpty" show variant="warning">
      <p class="text-center p-0 mb-0">Nothing Activity</p>
    </b-alert>
  </div>
</template>

<script>
  import { GoogleCharts } from 'google-charts';
  import { isEmpty } from 'lodash';

  export default {
    name: 'employee_activity',
    data() {
      return {};
    },
    created() {
      const { employeeId } = this.$route.params;
      this.$store.dispatch('employees/LOAD_DETAIL_DATA');
      this.$store.dispatch('employees/LOAD_EMPLOYEE_ACTIVITY', { employee_id: employeeId }).then(() => {
        if (!this.dataEmpty) {
          GoogleCharts.load(this.drawChart, { packages: ['timeline'] });
        }
      });
    },
    computed: {
      activities() {
        const activities = this.$store.getters['employees/get_activity'];
        const reformatData = [];
        const setStatus = (st) => {
          let newSattus = null;
          if (st === 'WORKING') {
            newSattus = 'Work';
          } else if (st === 'RESTING') {
            newSattus = 'Rest';
          } else if (st === 'STOP_WORKING') {
            newSattus = 'Stop';
          }
          return newSattus;
        };

        let lastData = null;
        activities.forEach((activity, i) => {
          const { created_at: endDate, status } = activity;

          if (!isEmpty(lastData)) {
            const { status: lastStatus, created_at: startDate } = lastData;

            if (status === lastStatus) return true;

            reformatData.push([
              setStatus(lastStatus),
              new Date(startDate),
              new Date(endDate),
            ]);
          }

          if (i === (activities.length - 1)) {
            reformatData.push([
              setStatus(status),
              new Date(endDate),
              new Date(endDate),
            ]);
          }

          lastData = activity;
          return true;
        });
        return reformatData;
      },
      dataEmpty() {
        return isEmpty(this.activities);
      },
    },
    methods: {
      drawChart() {
        const { chart: chartContainer } = this.$refs;
        const chart = new GoogleCharts.api.visualization.Timeline(chartContainer);
        const dataTable = new GoogleCharts.api.visualization.DataTable();
        const { activities } = this;

        dataTable.addColumn({ type: 'string', id: 'Activity' });
        dataTable.addColumn({ type: 'date', id: 'Start' });
        dataTable.addColumn({ type: 'date', id: 'End' });
        dataTable.addRows(activities);

        const options = {
          colors: ['#1e88e5', '#8bc34a', '#78909c'],
          timeline: {
            groupByRowLabel: true,
            colorByRowLabel: true,
          },
        };

        chart.draw(dataTable, options);
      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/pages/employee/detail/Activity.vue